import axios from './axios';

const EmployeeService = {
    getEmployees: async () => {
        try {
            const response = await axios.get('/employees');
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getEmployeesByEmployeeType: async (employee_type) => {
        try {
            const response = await axios.get('/employees', {params: {employee_type}});
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getEmployeeById: async (id) => {
        try {
            const response = await axios.get(`/employees/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    createEmployee: async (data) => {
        try {
            const response = await axios.post('/employees',  data);
            return response?.data?.data;
        } catch(e) {
            return e?.response?.data;
        }
    },
    updateEmployee: async (data,id) => {
        try {
            const response = await axios.put(`/employees/${id}`,  data);
            return response.data.data;
        } catch(e) {
            return e?.response?.data;
        }
    },
    employeeLogin: async (data) => {
        try {
            const response = await axios.post('/auth/employees/login',  data);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },

    deleteEmployee: async id => {
        try {
            const response = await axios.delete(`/employees/${id}`);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getAllServerAndHosts: async (data) =>{
        try{
            const response = await axios.get('/employees/pos/name',  {params: {restaurant_id: data}});
            return response.data.data;
        } catch(e){
            console.log(e);
        }
    },
    addEmployeType: async (data) => {
        const response = await axios.post('/employee-types',  data);
        return response?.data?.data || response;
    },
    updateEmployeType: async (data, id) => {
        try {
            const response = await axios.put(`/employee-types/${id}`,  data);
            return response.data.data;
        } catch(e) {
            console.error(e);
        }
    },
    getEmployeType: async (id) => {
        try{
            const response = await axios.get(`/employee-types`);
            return response.data.data;
        } catch(e){
            console.log(e);
        }
    },
    deleteEmployeType: async (id) => {
        try{
            const response = await axios.delete(`/employee-types/${id}`);
            return response.data.data;
        } catch(e){
            console.log(e);
        }
    },
    sendInvite: async (data) => {
            const response = await axios.post(`/employees/invite`, data);
            return response?.data?.data || response;
    },
    resend_otp: async (data) => {
        const response = await axios.post(`/employees/resend_otp`, data);
        return response?.data?.data || response;
    },
    getAllEmploye: async (page,text, type) => {
        try{
            const response = await axios.get(`/employees?page=${page}&search=${text}&employee_type_id=${type}`);
            return response.data.data;
        } catch(e){
            console.log(e);
        }
    },
    getEmployeById: async (id) => {
        try{
            const response = await axios.get(`/employees/${id}`);
            return response.data.data;
        } catch(e){
            console.log(e);
        }
    },
    deleteEmploye: async (id) => {
        try{
            const response = await axios.delete(`/employees/${id}`);
            return response.data.data;
        } catch(e){
            console.log(e);
        }
    },
    getDeactiveEmploye: async (id, page, text) => {
        try{
            const response = await axios.get(`/employees/deactivated?page=${page}&search=${text}`);
            return response.data.data;
        } catch(e){
            console.log(e);
        }
    },
    changeEmployeStatus: async (empId,id) => {
        try{
            const response = await axios.put(`/employees/${empId}/toggle_active`);
            return response.data.data;
        } catch(e){
            console.log(e);
        }
    },
};

export default EmployeeService;
